import UserDataService from "../../../Shared/Assets/userdata-service";
import { initPopover, empty, sendGAEvent } from '../../../Shared/Assets/utils';

export default class VerifyCode {
  constructor() {
    
  }

  init(formElement) {
    this.form = formElement;
    if (this.form.getAttribute('data-init') === "1") return false;
    this.form.setAttribute('data-init', "1");

    this.form.addEventListener('submit', this._handleFormSubmit);
    this.btnVerifyCode = this.form.btnVerifyCode;
    this.$validationField = $(this.form).find('.error-message');

    this._initResentCodeButton();
    initPopover();
  }

  _initResentCodeButton = () => {
    this.form.btnResentCode.addEventListener('click', evt => {
      let btn = evt.target;
      let url = btn.getAttribute("data-url");
      let data = {
        phoneNumber: this.form.PhoneNumber.value,
        networkId: this.form.NetworkId.value
      };

      $.ajax({
        url: url,
        type: 'POST',
        data: data,
        success: () => {
          $('.resend-code-text').text('SMS sent! Your unlock code has been sent to your mobile number.');
        },
        error: (error) => {
          $('.resend-code-text').text('There is an issue with the unlock code. Please try again later.');
          console.log(error);
        }
      });
    })
  }

  _handleFormSubmit = (evt) => {
    evt.preventDefault();
    console.debug('verify code');

    if (!this._validateForm()) {
      return false;
    }

    let form = evt.target;
    let actionUrl = form.action;
    let dataParam = {
      Code: form.Code.value,
      NetworkId: form.NetworkId.value,
      PhoneNumber: form.PhoneNumber.value
    }

    this._showLoading();
    let $this = this;

    $.ajax({
      url: actionUrl,
      type: 'POST',
      data: dataParam
    })
      .done(this._handleSuccessResponse)
      .fail(this._handleErrorResponse);

    return false;
  }

  _handleSuccessResponse = (result) => {
    this._hideLoading();

    $(".call-private-seller .contact-content")
      .empty()
      .append(result.htmlContent);

    if (!empty(result.userData)) {
      let userDataService = new UserDataService();
      userDataService.saveData(result.userData);
    }

    this._fireTracking(result.trackingData);
  }

  _handleErrorResponse = (error) => {
    this._hideLoading();

    if (empty(error.responseJSON)) {
      this._showError("We are experiencing difficulties verifying your number. Please try again later.");
      return;
    }

    if (!empty(error.responseJSON.htmlContent)) {
      this._showError(error.responseJSON.htmlContent);
    }

    this._fireTracking(error.responseJSON.trackingData);
  }

  _showLoading = () => {
    this.btnVerifyCode.classList.add('loading');
    this.btnVerifyCode.disabled = true;
  }

  _hideLoading = () => {
    this.btnVerifyCode.classList.remove('loading');
    this.btnVerifyCode.disabled = false;
  }

  _validateForm = () => {
    if (empty(this.form.Code.value) || this.form.Code.value.trim().length != 4) {
      this._showError("Please enter a valid code");
      return false;
    }
    if (!$(this.form).valid()) {
      return false;
    }

    return true;
  }

  _showError = (message) => {
    this.$validationField.text(message);
  }

  _fireTracking = (tracking) => {
    if (!empty(tracking) && !empty(tracking.label)) {
      sendGAEvent(tracking.category, tracking.label, tracking.action);
    }
  }
}